import { useCallback, useMemo } from 'react';
import { IConfirmedInputWithConfirmProps, IValue } from '../types';
import { useLanguageContext } from 'Context';

export function useFieldWithConfirmController(
  value: IConfirmedInputWithConfirmProps['value'],
  onChange: IConfirmedInputWithConfirmProps['onChange'],
) {
  const language = useLanguageContext();
  const onChangeInput = useCallback(
    (phoneVal: IValue) => {
      if (phoneVal !== value?.value) {
        const next = {
          ...value,
          value: phoneVal,
        };
        onChange?.(next);
      }
    },
    [value, onChange],
  );

  const onChangeConfirm = useCallback(
    (confirmPhone: string) => {
      const next = {
        ...value,
        confirmed: [...(value?.confirmed || []), confirmPhone],
      };
      onChange?.(next);
    },
    [onChange, value],
  );

  const isConfirmed = useMemo(() => {
    if (value?.confirmed) {
      return !!value?.confirmed?.includes(value?.value || '');
    }
    return false;
  }, [value]);

  const label = useMemo(() => {
    return language?.getTranslate('ui.confirm.verified');
  }, [language, language?.key]);

  return {
    onChangeInput,
    onChangeConfirm,
    isConfirmed,
    currentValue: value,
    label,
  };
}
